<script>
    import Mobilebtn from '../mobilebtn.svelte';
    import {initializeGsapAnimation} from '../../utils.js';
    import {onMount} from 'svelte';

    let main;
    let text1;
    let text2;
    let text3;
    let text4;
    let text5;
    let backImg;
    export let scrollPointers;
    export let updatedValue;

    onMount(onStart);
    /**
     */
    function onStart() {
        initializeGsapAnimation(
            main,
            scrollPointers,
            [
                {scrollValue: 1, duration: 1},
                {
                    scrollValue: 2,
                    duration: 1,
                    onUpdate: () => {
                        updatedValue = scrollPointers.scrollValue;
                    },
                },
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            text1,
            [
                {top: 'max(38.318vw,17.711vh)', duration: 3},
                {y: '7.523vw', duration: 3},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            text2,
            [
                {y: '-5vw', duration: 3},
                {y: '5vw', duration: 3},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            text3,
            [
                {y: '-5vw', duration: 3},
                {y: '5vw', duration: 3},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            text4,
            [
                {y: '-5vw', duration: 3},
                {y: '5vw', duration: 3},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            text5,
            [
                {bottom: 'max(117.951vw,54.6vh)', right: '53.196vw', duration: 3},
                {bottom: 'max(22.82vh,49.299vw)', right: '53.196vw', duration: 3},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            backImg,
            [
                {filter: 'grayscale(0)', duration: 5},
                {filter: 'grayscale(1)', duration: 5},
            ],
            3,
        );
    }
</script>

<section bind:this={main}>
    <div class="img" bind:this={backImg}>
        <img
            src="images/artimage2.png"
            alt="imageofart"
            width="100%"
            height="100%"
        />
    </div>
    <div class="text" bind:this={text5}><p>1</p></div>
    <div class="base">
        <h1 bind:this={text1}>VISUAL<br /> ARTISTS</h1>
    </div>
    <div class="para">
        <p bind:this={text2}>
            Colors, shapes and layout is the name of the game and you are the
            player. You see it in your head before it materializes and you know
            what goes with what.
        </p>
        <p bind:this={text3}>
            We’re building the future of entertainment. A future that expands
            your 2D canvas infinitely into a multidimensional multiverse. And
            for the first time, the canvas can almost keep up w951vwith your
            imagination.
        </p>
        <p bind:this={text4}>
            We want you to be the first to experience it and to help us choose
            the right color scheme and layout for it.
        </p>
    </div>
    <div class="btn">
        <Mobilebtn bgcolor="black" width="56.308vw" txtcolor="#59E7F2" state = "Artists & Musicians"/>

        <div class="div4">
            <p class="ar">></p>
        </div>
    </div>
</section>

<style>
    h1{
        margin: 0;
    }
    section {
        height: max(216.355vw,100vh);
        width: 100%;
        position: relative;
    }
    .base {
        color: #000000;
        font-style: normal;
    }
    .img {
        height: max(216.355vw,100vh);
        width: 100vw;
        filter: grayscale(1);
    }
    .base h1:nth-child(1) {
        font-family: Orbitron;
        font-weight: 700;
        font-size: 9.346vw;
        line-height: 9.346vw;
        position: absolute;
        top: max(38.318vw,17.711vh);
        left: 39.486vw;
        /* bottom: 5.477vw; */
    }
    .para {
        font-family: Orbitron;
        font-size: 2.804vw;
        line-height: 3.925vw;
    }
    .para p:nth-child(1) {
        font-weight: 400;
        position: absolute;
        top: max(69.486vw,32.169vh);
        width: 63.551vw;
        left: 11.916vw;
        z-index: 1;
    }
    .para p:nth-child(2) {
        font-weight: 600;
        position: absolute;
        width: 63.551vw;
        top: max(90vw,41.66vh);
        left: 11.916vw;
    }
    .para p:nth-child(3) {
        font-weight: 400;
        position: absolute;
        width: 63.551vw;
        top: max(117vw,54.166vh);
        left: 11.916vw;
    }
    .btn {
        position: absolute;
        bottom: max(3.24vh,7.009vw);
        left: 21.729vw;
    }
    .div4 {
        height: 2.336vw;
        width: 5.841vw;
        margin: auto;
        margin-top: max(10.748vw,4.9759vh);
    }
    .ar {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 700;
        font-size: 4.673vw;
        line-height: 5.841vw;
        letter-spacing: 0.06em;
        color: white;
        transform: rotate(90deg);
    }
    .text {
        position: absolute;
        right: 53.196vw;
        bottom: max(49.299vw,22.82vh);
        z-index: 0;
    }
    .text p {
        margin: 0;
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 700;
        font-size: 140.187vw;
        line-height: 100%;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: rgba(255, 255, 255, 0.4);
    }
</style>
